import styled from 'styled-components';

import { IBaseIconSet } from '@estee/elc-icons';

export interface ILink {
    label: string;
    url: string;
}

export interface ILogoImage {
    src: string;
    alt: string;
}

export interface IIconLink extends ILink {
    iconSetName: IBaseIconSet['iconSetName'];
}

const BaseLink = styled.a`
    cursor: pointer;
    display: block;
    text-decoration: none;
    transition: all 0.2s linear;
    &:focus {
        outline: rgb(0, 0, 0) thin dotted;
        transition: none;
    }
`;

export default BaseLink;
